import { makeObservable, observable } from 'mobx'

export type AttachedFileConfig = {
  url?: string
  signedId?: string
  filename?: string
}

export class AttachedFile {
  url: string
  signedId?: string
  filename: string

  constructor(config: AttachedFileConfig = {}) {
    this.url = config.url || ''
    this.signedId = config.signedId
    this.filename = config.filename || ''

    makeObservable(this, {
      url: observable,
      signedId: observable,
      filename: observable,
    })
  }

  static fromUpload(file: File, signedId: string): AttachedFile {
    return new AttachedFile({
      url: URL.createObjectURL(file),
      signedId,
      filename: file.name,
    })
  }

  toFileObject(mimeType: string): File {
    return new File([], this.filename, { type: mimeType })
  }

  isEmpty(): boolean {
    return !this.signedId && !this.url
  }

  clear(): void {
    this.url = ''
    this.signedId = ''
    this.filename = ''
  }

  // AttachedFileConfig (defined here) matches AttachedFileSchema (what comes from AI)
  static fromAI(
    file: { url: string; signedId: string | null; filename: string | null } | null
  ): AttachedFile {
    return file
      ? new AttachedFile({
          url: file.url,
          signedId: file.signedId || undefined,
          filename: file.filename || '',
        })
      : new AttachedFile({})
  }

  // Returns a value that matches AttachedFileSchema
  static toAI(file: AttachedFile | null): {
    url: string
    signedId: string | null
    filename: string | null
  } {
    return file
      ? {
          url: file.url || '',
          signedId: file.signedId || null,
          filename: file.filename,
        }
      : {
          url: '',
          signedId: null,
          filename: null,
        }
  }
}
